// Loader.js

import React from "react";
import "./style.css";
const PrimaryLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <div className="loading-text">Loading...</div>
    </div>
  );
};

export default PrimaryLoader;
